import __var_0__ from '@stdlib/math/base/assert/is-nonnegative-integer';
import __var_1__ from '@stdlib/utils/constant-function';
import __var_2__ from '@stdlib/math/base/special/factorialln';
import __var_3__ from '@stdlib/stats/base/dists/degenerate/logpmf';
import __var_4__ from '@stdlib/math/base/assert/is-nan';
import __var_5__ from '@stdlib/math/base/special/ln';
import __var_6__ from '@stdlib/constants/math/float64-ninf';
import __var_7__ from '@stdlib/constants/math/float64-pinf';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isNonNegativeInteger = __var_0__;
var constantFunction = __var_1__;
var factorialln = __var_2__;
var degenerate = __var_3__.factory;
var isnan = __var_4__;
var ln = __var_5__;
var NINF = __var_6__;
var PINF = __var_7__;


// MAIN //

/**
* Returns a function for evaluating the natural logarithm of the probability mass function (PMF) for a Poisson distribution with mean parameter `lambda`.
*
* @param {NonNegativeNumber} lambda - mean parameter
* @returns {Function} logPMF
*
* @example
* var logpmf = factory( 1.0 );
* var y = logpmf( 3.0 );
* // returns ~-2.792
*
* y = logpmf( 1.0 );
* // returns ~-1.0
*/
function factory( lambda ) {
	if ( isnan( lambda ) || lambda < 0.0 ) {
		return constantFunction( NaN );
	}
	if ( lambda === 0.0 ) {
		return degenerate( 0.0 );
	}
	return logpmf;

	/**
	* Evaluates the natural logarithm of the probability mass function (PMF) for a Poisson distribution.
	*
	* @private
	* @param {number} x - input value
	* @returns {number} evaluated logPMF
	*
	* @example
	* var y = logpmf( 2.0 );
	* // returns <number>
	*/
	function logpmf( x ) {
		if ( isnan( x ) ) {
			return NaN;
		}
		if ( isNonNegativeInteger( x ) && x !== PINF ) {
			return ( x * ln( lambda ) ) - lambda - factorialln( x );
		}
		return NINF;
	}
}


// EXPORTS //
export default factory;
